import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {ModbusRegister} from '@models/adminstration/gateway/gateway-configuration/modbus-register';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {BYTE_ORDER} from '@constants/administration/gateway/byte-order';
import {TranslateService} from '@ngx-translate/core';
import {ModbusSignal} from '@models/adminstration/gateway/gateway-configuration/modbus-signal';
import {DATA_TYPE} from '@constants/data-type.constant';

@Component({
    selector: 'scitis-admin-gateway-modbus-register',
    templateUrl: './gateway-modbus-register.component.html',
    styleUrls: ['./gateway-modbus-register.component.scss'],
    standalone: false
})
export class GatewayModbusRegisterComponent implements OnInit, OnChanges {

  @Input()
  register: ModbusRegister = new ModbusRegister();

  @Input()
  signalNames: string[] = [];

  @Output()
  signalFormIsValid = new EventEmitter<boolean>();

  @Output()
  registerFormIsValid = new EventEmitter<boolean>();

  @Output()
  removeRegisterChangeEvent = new EventEmitter<ModbusRegister>();

  @Output()
  removeSignalChangeEvent = new EventEmitter<ModbusSignal>();

  byteOrderValues = Object.values(BYTE_ORDER);
  byteOrder: string[] = [];
  modbusRegisterForm: UntypedFormGroup = new UntypedFormGroup({});
  REGISTER_ADDRESS_MIN: number = 0;

  private SIGNAL_NAME_CONVENTION = 'modbus_signal_';
  private MAX_INT16_VALUE: number = 65535;
  private DEFAULT_DATA_TYPE = DATA_TYPE.INT16;

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setTranslatedByteOrderArray();
    this.generateModbusRegisterForm(this.register);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.register?.firstChange) {
      this.formControls.address.setValue(this.register.address);
      this.register.signals.forEach(signal => signal.hasChanged = true);
      this.register.signals = [...this.register.signals];
      this.registerFormIsValid.emit(!this.modbusRegisterForm.invalid);
    }
  }

  get formControls() {
    return this.modbusRegisterForm.controls;
  }

  onRemoveSignal(signal: ModbusSignal) {
    const index = this.register.signals.indexOf(signal);
    if (index < 0) {
      return;
    }
    this.register.signals.splice(index, 1);
    this.removeSignalChangeEvent.emit(signal);
  }

    onSignalFormIsValid(valid: boolean) {
    this.signalFormIsValid.emit(valid);
  }

  onAddSignal() {
    if (!this.register.signals) {
      this.register.signals = [];
    }
    const name = this.getUniqueSignalName(this.signalNames.length);
    this.signalNames.push(name);
    const newSignal: ModbusSignal = {
      bitmask: this.MAX_INT16_VALUE,
      name: name,
      order: 0,
      type: this.DEFAULT_DATA_TYPE
    };
    this.register.signals.push(newSignal);
  }

  onRemoveRegister() {
    this.removeRegisterChangeEvent.emit(this.register);
  }

  onUpdateAddress() {
    this.register.address = this.formControls.address.value;
    this.registerFormIsValid.emit(!this.modbusRegisterForm.invalid);
  }

  private generateModbusRegisterForm(register: ModbusRegister) {
    this.modbusRegisterForm = new UntypedFormGroup({
      address: new UntypedFormControl(register.address, [Validators.required, Validators.min(this.REGISTER_ADDRESS_MIN)])
    });
    this.registerFormIsValid.emit(!this.modbusRegisterForm.invalid);
  }

  private setTranslatedByteOrderArray() {
    for (const element of this.byteOrderValues) {
      this.byteOrder = [...this.byteOrder, this.translate.instant(element)];
    }
  }

  private getUniqueSignalName(index: number): string {
    const signalName = this.SIGNAL_NAME_CONVENTION + index;
    if (this.signalNames.indexOf(signalName) !== -1) {
      index += 1;
      return this.getUniqueSignalName(index);
    }
    return signalName;
  }

}
